import { IItem } from "./PopOverMenu";
import "./style/PopOverMenuItem.scss";

export const PopOverMenuItem = ({ icon: Icon, title, onClick }: IItem) => {
  return (
    <button className="PopOverMenuItem" onClick={onClick}>
      <div className="PopOverMenuItem-Img">
        <Icon />
      </div>
      <span className="PopOverMenuItem-Title">{title}</span>
    </button>
  );
};
